export const enum ValidationMode {
  Aggressive = "aggressive",
  Lazy = "lazy",
  Passive = "passive",
  Eager = "eager"
}
